const sortByOrder = (a, b) => a.order - b.order;

const sortPaymentMethods = (paymentMethods) => paymentMethods.slice().sort(sortByOrder);

export { sortPaymentMethods };
